
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 85.333 512 341.333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFF","d":"M0 85.331h512v341.326H0z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M0 211.473h512v89.043H0z"}}),_c('g',{attrs:{"fill":"#0052B4"}},[_c('path',{attrs:{"d":"M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z"}})])])
          )
        }
      }
    